import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ADD_CARD_ANIMATION_MS = 720;

class ConversationAddCard extends PureComponent {
    constructor(props) {
        super(props);

        this.animationTimeoutId = null;
    }

    componentDidUpdate(prevProps) {
        if(prevProps.phase === this.props.phase) {
            return;
        }

        this.clearAnimationTimeout();

        const { phase } = this.props;
        if(phase === 'exiting' || phase === 'entering') {
            if(typeof window !== 'undefined') {
                this.animationTimeoutId = window.setTimeout(() => {
                    this.handleAnimationComplete(phase);
                }, ADD_CARD_ANIMATION_MS + 50);
            }
        }
    }

    componentWillUnmount() {
        this.clearAnimationTimeout();
    }

    clearAnimationTimeout = () => {
        if(this.animationTimeoutId != null) {
            window.clearTimeout(this.animationTimeoutId);
            this.animationTimeoutId = null;
        }
    };

    handleAnimationComplete = phase => {
        if(this.props.phase !== phase) {
            return;
        }

        const { onAnimationComplete } = this.props;
        if(phase === 'exiting' || phase === 'entering') {
            this.clearAnimationTimeout();
            onAnimationComplete(phase);
        }
    };

    handleAnimationEnd = event => {
        if(event.target !== event.currentTarget) {
            return;
        }

        const { phase } = this.props;
        if(
            (phase === 'exiting' && event.animationName === 'conversations-lux-add-card-exit')
            || (phase === 'entering' && event.animationName === 'conversations-lux-add-card-enter')
        ) {
            this.handleAnimationComplete(phase);
        }
    };

    handleOpen = () => {
        if(this.props.phase === 'closed') {
            this.props.onOpen();
        }
    };

    render() {
        const { intl, phase } = this.props;
        const isInteractive = phase === 'closed';

        return (
            <div className="conversations-lux-add-card-particle">
                <div
                    className={classNames(
                        'conversations-lux-add-card',
                        phase === 'exiting' && 'conversations-lux-add-card--exiting',
                        phase === 'entering' && 'conversations-lux-add-card--entering',
                        phase === 'open' && 'conversations-lux-add-card--hidden',
                    )}
                    onAnimationEnd={this.handleAnimationEnd}
                >
                    <button
                        type="button"
                        className="conversations-lux-add-btn"
                        onClick={this.handleOpen}
                        disabled={!isInteractive}
                        aria-expanded={phase !== 'closed'}
                        aria-label={intl.formatMessage({ id: 'conversationAddTitle', defaultMessage: 'Create a book' })}
                    >
                        <span className="conversations-lux-add-btn__plus" aria-hidden="true">+</span>
                    </button>
                </div>
            </div>
        );
    }
}

ConversationAddCard.propTypes = {
    intl: PropTypes.object.isRequired,
    phase: PropTypes.oneOf(['closed', 'exiting', 'open', 'entering']).isRequired,
    onOpen: PropTypes.func.isRequired,
    onAnimationComplete: PropTypes.func.isRequired,
};

export default ConversationAddCard;
